import {createSlice} from '@reduxjs/toolkit';

import {CurrentUser} from '~shared/models';

import {getMyUserInfo, getResolvedUserInfo} from './thunks';

export type CurrentUserState = CurrentUser & {resolvedDisplayName?: string};

const initialState: CurrentUserState = {
    login: '',
    uid: '',
    sk: '',
    displayName: '',
    passportId: '',
    avatarId: '',
    avatarHost: '',
    yandexuid: '',
    accounts: [],
    availableRecoveryTokenTypes: [],
};

export const {reducer} = createSlice({
    name: 'user',
    initialState,
    reducers: {},
    extraReducers: (builder) =>
        builder
            .addCase(getMyUserInfo.fulfilled, (state, action) => {
                const {home_cluster: homeCluster, available_recovery_token_types} = action.payload;
                state.availableRecoveryTokenTypes = available_recovery_token_types;
                state.homeCluster = homeCluster;
            })
            .addCase(getResolvedUserInfo.fulfilled, (state, action) => {
                const user = action.payload.users[0];
                if (!user) {
                    return;
                }
                state.resolvedDisplayName = user.display_name;
            }),
});
